export default __webpack_public_path__ + "static/media/q19.b5f052e8.png";